import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState(['user']),
    // ...mapGetters(['orgSelectable', 'stateSelectable', 'citySelectable', 'groupSelectable', 'groupSelectorInitGroup'])
  }
}